import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { INotification } from '@obvious.tech/constellation'

export const Notification = defineEntity('Notification', {
  endpoint: 'notifications/api/Notification',
  schema: SNoop<INotification>(),
})
